import { Key } from 'react'
import {
  Empty,
  Form,
  FormInstance,
  Modal,
  ModalProps,
  Skeleton,
} from 'components/common'
import {
  VariantSelectTree as Tree,
  VariantSelectTreeProps as TreeProps,
} from '../trees/VariantSelectTree'
import { OrderLineItem } from 'lib/graphql/storeadmin'

export interface VariantSelectorModalProps
  extends Omit<TreeProps, 'formName'>,
    Omit<ModalProps, 'onOk'> {
  form: FormInstance
  checkedKeys: Key[]
  onCheck: (checkedKeys: Key[]) => void
  onClose: (value: boolean) => void
  loading?: boolean
  lineItems: OrderLineItem[]
}

export interface VariantSelectorModalForm {
  tree: Key[]
}

export const VariantSelectorModal = ({
  data,
  checkedKeys,
  form,
  oldBooks,
  onCheck,
  onClose,
  open,
  loading,
  lineItems,
}: VariantSelectorModalProps) => {
  const onSubmit = (values: VariantSelectorModalForm) => {
    // onOk 時に setCheckedKeys する。その前は Form でコントロール
    onCheck(values.tree)
    onClose(false)
  }
  const onTreeCheck = (values: Key[]) => {
    form.setFieldsValue({ tree: values })
  }

  return (
    <Modal
      title={'施設を選択する'}
      okText={'OK'}
      cancelText={'キャンセル'}
      open={open}
      onOk={() => {
        form.validateFields().then((values) => {
          onSubmit(values)
        })
      }}
      onCancel={() => onClose(false)}
      bodyStyle={{ height: 400, overflowY: 'scroll' }}
    >
      {data?.productAvailabilities?.edges?.length > 0 ? (
        <Form form={form}>
          <Tree
            data={data}
            checkedKeys={checkedKeys}
            onCheck={onTreeCheck}
            oldBooks={oldBooks}
            formName="tree"
            lineItems={lineItems}
          />
        </Form>
      ) : (
        <>{loading ? <Skeleton /> : <Empty />}</>
      )}
    </Modal>
  )
}
